<template>
  <BasePanelWithHeader headerText="Tracked Bills">
    <template v-slot:content>
      <v-row>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.trackedBillForm.addTrackedBill()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Tracked Bill
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="trackedBills"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.trackedBillForm.editTrackedBill(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit Tracked Bill
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.trackedBillDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Tracked Bill
          </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="trackedBillDelete"
        :delete="deleteTrackedBill"
        @refresh="loadTrackedBills"
      >
        Are you sure you want to delete this tracked bill?
      </BaseDeleteConfirm>
      <TrackedBillDialogForm ref="trackedBillForm" @refresh="loadTrackedBills">
      </TrackedBillDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillDialogForm from '@components/form/add-edit/TrackedBillDialog'
export default {
  components: {
    TrackedBillDialogForm,
  },
  data: () => ({
    searchText: '',
  }),
  created() {
    this.loadTrackedBills()
  },
  computed: {
    ...get('trackedBill', ['trackedBills', 'loading']),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Bill Number',
          align: 'center',
          sortable: true,
          value: 'BillNumber',
          visible: true,
        },
        {
          text: 'Year',
          align: 'center',
          sortable: true,
          value: 'Year',
          visible: true,
        },
        {
          text: 'Special Session',
          align: 'center',
          sortable: true,
          value: 'SpecialSession',
          visible: true,
        },
        {
          text: 'Short Title',
          align: 'center',
          sortable: true,
          value: 'ShortTitle',
          visible: true,
        },
        {
          text: 'Bill Type',
          align: 'center',
          sortable: true,
          value: 'BillType',
          visible: true,
        },
        {
          text: 'Sponsor',
          align: 'center',
          sortable: true,
          value: 'Sponsor',
          visible: true,
        },
        {
          text: 'Synopsis',
          align: 'center',
          sortable: true,
          value: 'Synopsis',
          visible: true,
        },
        {
          text: 'Pros',
          align: 'center',
          sortable: true,
          value: 'Pros',
          visible: true,
        },
        {
          text: 'Cons',
          align: 'center',
          sortable: true,
          value: 'Cons',
          visible: true,
        },
        {
          text: 'Proposed Changes',
          align: 'center',
          sortable: true,
          value: 'ProposedChanges',
          visible: true,
        },
        {
          text: 'Contact',
          align: 'center',
          sortable: true,
          value: 'Contact',
          visible: true,
        },
        {
          text: 'Is Private',
          align: 'center',
          sortable: true,
          value: 'IsPrivate',
          visible: true,
        },
        {
          text: 'Concern ID',
          align: 'center',
          sortable: true,
          value: 'ConcernID',
          visible: true,
        },
        {
          text: 'Priority ID',
          align: 'center',
          sortable: true,
          value: 'PriorityID',
          visible: true,
        },
        {
          text: 'Created By ID',
          align: 'center',
          sortable: true,
          value: 'CreatedByID',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: true,
        },
        {
          text: 'Created Date',
          align: 'center',
          sortable: true,
          value: 'CreatedDate',
          visible: true,
        },
        {
          text: 'Updated Date',
          align: 'center',
          sortable: true,
          value: 'UpdatedDate',
          visible: true,
        },
        {
          text: 'Updated By ID',
          align: 'center',
          sortable: true,
          value: 'UpdatedByID',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('trackedBill', ['deleteTrackedBill', 'loadTrackedBills']),
  },
}
</script>
<style>
</style>